import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { useRoute } from 'shared/src/hooks/useRoute';
import type { MyPageParamList } from 'mypage/src/hooks/useMyPageRoute';
import AddressListScreen from './AddressListScreen';
import AddressEditor from '../AddressEditor';
import ZipcodeSearch from '../ZipcodeSearch';
import type { AddressStackParamList } from './AddressStackParamList';

const Stack = createNativeStackNavigator<AddressStackParamList>();

/**
 * 배송지 Stack 컨테이너.
 * - native VC 한 개 안에서 List/Editor/Zipcode를 react-navigation Stack으로 묶음.
 * - 외부에서는 AddressList 진입(`screen=AddressList`)만 가능.
 * - 결제 select 콜백은 List가 `bridge.deliverScreenResult`로 native owner에게 그대로 전달.
 */
const AddressList = () => {
  const { params } = useRoute<MyPageParamList, 'AddressList'>();
  return (
    <Stack.Navigator screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="AddressList"
        component={AddressListScreen}
        initialParams={params}
      />
      <Stack.Screen name="Editor" component={AddressEditor} />
      <Stack.Screen name="Zipcode" component={ZipcodeSearch} />
    </Stack.Navigator>
  );
};

export default AddressList;
